export default "__VITE_ASSET__70879560__"